import { request } from '@/utils/request'
const MajorAccountManageService = {
  state: {},

  mutations: {},

  actions: {
    // 大客户分页
    GetAllCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/Customer_MainInfo/GetAllCustomer', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存大客户
    SaveCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Customer_MainInfo/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除大客户
    DeleteCustomer({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Customer_MainInfo/DeleteByObjectID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default MajorAccountManageService
